"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _basic = _interopRequireDefault(require("./_basic"));
var _bluebird = _interopRequireDefault(require("bluebird"));
class DashboardApi extends _basic.default {
  /**
   * @constructor
   */
  constructor(_ref) {
    let {
      dataHubUrl,
      userTokenFactory
    } = _ref;
    super({
      userTokenFactory
    });
    this.dataHubUrl = dataHubUrl;
  }
  dashboardNavUrl(_ref2) {
    let {
      accId,
      usrId
    } = _ref2;
    return `${this.dataHubUrl}/acc/${accId}/usr/${usrId}/dashboard/nav`;
  }
  dashboardViewUrl(_ref3) {
    let {
      accId,
      usrId,
      viewId
    } = _ref3;
    return `${this.dataHubUrl}/acc/${accId}/usr/${usrId}/dashboard/${viewId}`;
  }
  dashboardCustomViewUrl(_ref4) {
    let {
      accId,
      usrId,
      viewId,
      accountId
    } = _ref4;
    return `${this.dataHubUrl}/acc/${accId}/usr/${usrId}/dashboard/${viewId}/cstm/${accountId}`;
  }
  async getNavigation(_ref5) {
    let {
      accId,
      usrId
    } = _ref5;
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.get(this.dashboardNavUrl({
      accId,
      usrId
    }), headers)).then(response => _bluebird.default.resolve(response.data));
  }
  async getViewById(_ref6) {
    let {
      accId,
      usrId,
      viewId,
      accountId = null
    } = _ref6;
    const headers = await this.getHeaders();
    const url = accountId ? this.dashboardCustomViewUrl({
      accId,
      usrId,
      viewId,
      accountId
    }) : this.dashboardViewUrl({
      accId,
      usrId,
      viewId
    });
    return _bluebird.default.try(() => _axios.default.get(url, headers)).then(response => _bluebird.default.resolve(response.data));
  }
}
var _default = DashboardApi;
exports.default = _default;